<template>
  <!-- <div class="d-flex flex-column justify-space-between full-height pt-6"> -->
  <v-row justify="center" align="center" class="full-width full-height pt-6" no-gutters>
    <v-col cols="12" sm="7" md="8" lg="7" xl="7">
      <div class="rounded-lg py-5">
        <transition :name="slideDirection" mode="out-in">
          <v-card
            v-if="survey !== null"
            :key="keys.survey"
            class="main-card text-left"
            elevation="0"
            rounded="2"
          >
            <div class="main-card-content survey-card">
              <Survey
                :moduleId="survey.learningModuleId"
                :displayName="survey.displayName"
                :chapterId="
                  survey.LearningChapters && survey.LearningChapters[0]
                    ? survey.LearningChapters[0].learningChapterId
                    : null
                "
                :survey="survey"
                :completedStatus="surveyCompleted"
                :whistleToken="token.token"
                :email="token.externalUserId"
                :surveyClientId="survey.clientId"
                :showBackButton="false"
                :postLearningLog="postLearningLog"
                @surveyCompleted="onSurveyCompleted"
                @update-completed="surveyCompleted = $event"
                @retakeSurvey="surveyCompleted = false"
              />
            </div>
          </v-card>
          <v-card v-else :key="keys.loading" class="main-card text-left" elevation="0" rounded="2">
            <div class="main-card-content d-flex flex-column align-center pt-12 text-center">
              <Typography variant="h-3">Loading your survey...</Typography>
              <Robin
                :key="`robin-${!!errorMessage}`"
                :showText="false"
                :width="140"
                :height="140"
                animation="inflatableDance"
                :loop="!errorMessage"
              />
              <Typography v-if="errorMessage" variant="h-3" class="error--text">{{
                errorMessage
              }}</Typography>
            </div>
          </v-card>
        </transition>
      </div>
    </v-col>
  </v-row>
  <!-- </div> -->
</template>

<script>
// Components
import Survey from "@/components/learning/SurveyV3.vue";
import Robin from "@/components/Robin.vue";
import Typography from "@/components/generic/Typography.vue";

// Services
import TokenService from "@/services/TokenService";
import LearningService from "@/services/LearningService";

// Packages
import { mapState } from "vuex";
import moment from "moment";

// Mixins
import confettiMixin from "@/mixins/confettiMixin";
import whitelabelMixin from "@/mixins/whitelabelMixin";

export default {
  name: "SurveysPublicV2",
  title: "Surveys",
  mixins: [confettiMixin, whitelabelMixin],
  components: {
    Survey,
    Robin,
    Typography,
  },
  props: {},
  data() {
    return {
      surveyId: null,
      survey: null,
      token: null,
      loadingSurvey: false,
      surveyCompleted: false,
      errorMessage: null,
      currentSlide: 0,
      keys: {
        loading: 1,
        survey: 2,
      },
      slideDirection: "topic-left",
    };
  },
  mounted() {
    this.surveyId = this.$route.params.surveyId;
    this.getSurveyAndToken();
  },
  beforeUnmount() {},
  methods: {
    getSurveyAndToken() {
      this.loadingSurvey = true;
      console.log("getting survey and token!");

      // Clearing error message JUST in case!
      this.errorMessage = null;
      LearningService.getPublicSurveyAndToken(this.surveyId)
        .then((response) => {
          // this is checking for an empty response
          if (Object.values(response).length > 0) {
            const survey = JSON.parse(JSON.stringify(response.data.module));
            const token = JSON.parse(JSON.stringify(response.data.token));
            this.token = token;
            this.survey = survey;
          } else {
            console.log("ERROR: No survey found");
            this.errorMessage = "Something went wrong, please try again.";
          }
        })
        .catch((err) => {
          console.log("Error when fetching survey ", err);
          let errorCode = (err.data && err.data.error_code) || "";
          let code = Number(errorCode.slice(-2));
          switch (code) {
            case 12:
              this.errorMessage = `You'll need to sign in to your ${this.applicationName} account to take this survey.`;
              break;
            case 13:
              this.errorMessage = "Whoops, we're having trouble finding that survey.";
              break;
            case 14:
              this.errorMessage = "It looks like you've already taken this survey.";
              break;
            default:
              this.errorMessage = "Something went wrong. Please try again.";
          }
        })
        .finally(() => {
          this.loadingSurvey = false;
        });
    },
    isTokenValid() {
      if (moment(this.token.createdAt).add(this.token.tokenTTL, "seconds") < moment().utc()) {
        return false;
      } else {
        return true;
      }
    },
    getNewToken() {
      console.log("!!!!!!!In public survey, getting new token!!!!!!!");
      let tokenArr = [];
      let body = {
        clientId: this.token.clientId,
        externalUserId: this.token.externalUserId,
        ipAddress: null,
        context: this.token.context,
        contextResourceId: this.token.contextResourceId,
        tokenTTL: this.token.tokenTTL,
        numUses: this.token.numUses,
        createdBy: this.token.createdBy,
        updatedBy: this.token.createdAt,
      };
      return TokenService.createToken(body)
        .then((res) => {
          tokenArr = res;
          let sortedArr = tokenArr.sort((a, b) => {
            return moment(a.createdAt).diff(b.createdAt);
          });
          let latestToken = sortedArr[tokenArr.length - 1];
          return latestToken;
        })
        .catch((err) => {
          console.log("Error when getting new token ", err);
        });
    },
    onSurveyCompleted() {
      this.surveyCompleted = true;
      this.playConfetti("special");
    },
    async postLearningLog(card, options = {}) {
      const { returnLog = false, extraLogs = [] } = options;
      if (this.isTokenValid() === false) {
        let newToken = await this.getNewToken();
        this.token = newToken;
      }
      const body = {
        externalUserId: this.token.externalUserId,
        userId: this.userProfile ? this.userProfile.userId : null,
        clientId: this.token.clientId,
        learningCardId: card.learningCardId,
        learningCardAssociationId: card.learningCardAssociationId,
        completed: true,
        completedDate: new Date(),
        score: null,
      };
      const logs = await Promise.resolve(extraLogs);
      logs.push(body);
      if (!returnLog) {
        console.log("Inserting " + logs.length + " learning logs.");
        await LearningService.createLearningLog(logs, [], this.token.token);
      } else {
        return logs;
      }
    },
    restartSurvey() {
      // SurveyV3 resets itself on retakeSurvey; keep for any other side effects
      this.surveyCompleted = false;
    },
  },
  computed: {
    ...mapState(["userProfile", "clients", "postItArray"]),
  },
};
</script>

<style scoped>
/* Controls styling for the card component in 
the main container. Shows survey card */
.main-card {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 10px 10px 10px 10px !important;
  padding: 24px;
}

/* Inner content for main card so it has smaller margins when on mobile*/
.main-card-content {
  min-width: 60%;
  height: 100%;
  min-height: 60vh;
}

/* Survey content: only as tall as needed (no extra empty space) */
.survey-card {
  min-height: 0;
  height: auto;
  margin-left: 0;
  margin-right: 0;
  width: 100%;
}

@media screen and (min-width: 960px) {
  .main-card-content {
    margin-left: 10%;
    margin-right: 10%;
  }
}
@media screen and (min-width: 451px) {
  .main-card-content {
    margin-left: 20px;
    margin-right: 20px;
  }
}
@media screen and (max-width: 450px) {
  .main-card {
    margin-left: 0px;
    margin-right: 0px;
  }
  .main-card-content {
    margin-left: 0px;
    margin-right: 0px;
  }
}
</style>
